var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"35.2632","height":"35.2632","transform":"matrix(-1 0 0 1 36 1.36841)","stroke":"black","key":0}),React.createElement("path",{"d":"M18.3685 10.1842C17.979 10.1842 17.6633 10.5 17.6633 10.8895V18.2947H10.258C9.86848 18.2947 9.55273 18.6105 9.55273 19C9.55273 19.3895 9.86848 19.7053 10.258 19.7053H17.6633V27.1105C17.6633 27.5 17.979 27.8158 18.3685 27.8158C18.758 27.8158 19.0738 27.5 19.0738 27.1105V19.7053H26.479C26.8686 19.7053 27.1843 19.3895 27.1843 19C27.1843 18.6105 26.8686 18.2947 26.479 18.2947H19.0738V10.8895C19.0738 10.5 18.758 10.1842 18.3685 10.1842Z","fill":"black","key":1})]);
}

Plus.defaultProps = {"width":"37","height":"38","viewBox":"0 0 37 38","fill":"white"};

module.exports = Plus;

Plus.default = Plus;
